import { c as _c } from "react/compiler-runtime";
import { useChatMessages } from '@ai-sdk-tools/store';
import { IconAdd2 } from '@newfront-insurance/core-ui';
import { IconButtonAsButton, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@newfront-insurance/core-ui/v2';
import { useChatOverlayContext } from '../../contexts/chat-overlay-context';
interface NewChatButtonProps {
  className?: string;
}

/**
 * Button component for starting a new chat.
 * Uses chat overlay context to manage chat state.
 * Uses store messages to determine if button should be enabled
 * (since it's inside ChatProvider).
 */
export function NewChatButton(t0) {
  const $ = _c(8);
  const {
    className
  } = t0;
  const {
    startNewChat,
    isSidebarOpen
  } = useChatOverlayContext();
  const messages = useChatMessages();
  const hasAnyMessages = messages.length > 0;
  if (isSidebarOpen) {
    return null;
  }
  const t1 = !hasAnyMessages;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconAdd2 color="currentColor" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== className || $[2] !== startNewChat || $[3] !== t1) {
    t3 = <TooltipTrigger asChild={true}><IconButtonAsButton onClick={startNewChat} disabled={t1} className={className}>{t2}</IconButtonAsButton></TooltipTrigger>;
    $[1] = className;
    $[2] = startNewChat;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <TooltipContent>Start a New Chat</TooltipContent>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <TooltipProvider><Tooltip>{t3}{t4}</Tooltip></TooltipProvider>;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}